export default __webpack_public_path__ + "static/media/36_front.d40cd880.png";